import React from "react";

import GeneralAccessManagement from "./GeneralAccess";
import AnalyticsViewManagement from "./View";

// Importing redux components
import { useSelector } from "react-redux";

// Import utilities
import { isAllowedToDo, isAllowedToDoByKey } from "permissions-hub";
import { ACCEPTED_PERMISSIONS, EMPLOYEE_MANAGEMENT } from "constants";
import { getAllowedPermissions } from "utils/authentication";

const AnalyticsManagement = ({ permissions, isAllowedToUpdatePayrollNotes }) => {
  
  const { userInfo: loggedUserInfo } = useSelector((state) => state.auth);

  // Check read permission
  const isAllowedToRead = isAllowedToDo(
    ACCEPTED_PERMISSIONS["read"],
    permissions
  );

  // Check update permission in employee management
  const isAllowedToUpdate = isAllowedToDoByKey(
    EMPLOYEE_MANAGEMENT,
    ACCEPTED_PERMISSIONS["update"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  // Pass AnalyticsViewManagement as a prop if isGeneralAccess is true
  const ManagementComponent = (isAllowedToRead && !isAllowedToUpdate) ? (
    <AnalyticsViewManagement />
  ) : (
    <GeneralAccessManagement
      isAllowedToUpdate={isAllowedToUpdate}
      isAllowedToUpdatePayrollNotes={isAllowedToUpdatePayrollNotes}
      AnalyticsViewManagement={AnalyticsViewManagement}
    />
  );
  return ManagementComponent;
};

export default AnalyticsManagement;
